module.exports = __webpack_public_path__ + "static/media/male-yellow-v3.d328147c.svg";